import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=2f1d9c1d&scoped=true&"
import script from "./Form2.vue?vue&type=script&lang=js&"
export * from "./Form2.vue?vue&type=script&lang=js&"
import style0 from "./Form2.vue?vue&type=style&index=0&id=2f1d9c1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1d9c1d",
  null
  
)

export default component.exports